import MDTypography from "components/MDTypography";
import GetAccessExernalValidation from "../assets/get_access_to_external_api_fund_request_val.png";
import MDBadge from "components/MDBadge";

const requestHeaderTableData = {
  columns: [
    { Header: "S/N", accessor: "num", align: "left", width: "5%" },
    { Header: "Key", accessor: "key", align: "left", width: "20%" },
    { Header: "Value", accessor: "value", align: "left" },
  ],
  rows: [
    {
      num: (
        <MDTypography
          component="p"
          variant="button"
          color="text"
          fontWeight="regular"
        >
          1
        </MDTypography>
      ),
      key: (
        <MDTypography
          component="p"
          variant="button"
          color="text"
          fontWeight="regular"
        >
          Authorization
        </MDTypography>
      ),
      value: (
        <MDTypography
          component="p"
          variant="caption"
          color="text"
          fontWeight="regular"
        >
          {"Bearer <access_token>"}
        </MDTypography>
      ),
    },
  ],
};

const requestBodyColumnHeaders = [
  { Header: "S/N", accessor: "num", align: "left", width: "5%" },
  { Header: "Field Name", accessor: "fieldName", align: "left", width: "20%" },
  { Header: "", accessor: "dataType", align: "center", width: "10%" },
  { Header: "Description", accessor: "description", align: "left" },
];

let fundingApiData = [
  {
    mainHeadingStatic: "Introduction",
    mainGridIdStatic: "introduction",
    mainHeadingDescStatic:
      "The API is designed to ensure that the fund approval process is as easy as possible. Please follow the guidelines of the API and in case of any questions, please contact relevant personnel within Gato Systems. This document should be utilized by customers/clients/users to consider the API while designing the solution.",
  },
  {
    mainHeadingStatic: "The Function of External API",
    mainGridIdStatic: "the-function-external-api",
    mainHeadingDescStatic:
      "The External API allows users to generate fund requests. It checks for the Banking Instruction Setup (BIS) in the system, if it exists, then the API delivers the new fund request to the approver based on the approval flow configured by the user. The general approval flow for a successfully created fund request is illustrated below:",
    mainHeadingDescStaticTwo:
      "Banking Instruction Setup is required to process a fund request. If it doesn’t exist in the system, the External API will create the Banking Instruction Setup with the provided details first, followed by the fund request.",
    diagramOneLabel: "Diagram 1: Fund Request Approval Flows",
    diagramTwoLabel: "Diagram2: External API Process",
  },
  {
    mainHeadingStatic: "Environment",
    mainGridIdStatic: "environment",
    mainHeadingDescStatic: "For the Base URL, please contact:",
    email: [
      "customersupport@gatosystems.com",
      "tradingops@gatosystems.com",
    ],
  },
  {
    mainHeading: "Authorization",
    mainHeadingDesc:
      "The user will provide login credentials to get tokens to access the External Fund Request API. Credentials should be in JSON format and the request type should be POST. To get the access token, credentials must be passed to the API using the URL below:",
    mainGridId: "authorization",
    accessTokenId: "",
    endPointHeading: "Request Endpoint",
    endpointId: "get-access-token-request-endpoint",
    endPointMethod: "POST",
    endPointDesc: "<base-url>/api/Authentication/login",
    requestBody: "Request Body",
    requestBodyId: "get-access-token-request-body",
    requestBodyTable: {
      columns: [...requestBodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Email<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          dataType: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
                sx={{ "& .MuiBadge-badge": { background: "#022DEC", backgroundImage: "none" } }}
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              The email is assigned to the user for login.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Password<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          dataType: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
                sx={{ "& .MuiBadge-badge": { background: "#022DEC", backgroundImage: "none" } }}
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The password is assigned to the user for login.
            </MDTypography>
          ),
        },
      ],
    },
    respObjKey: "login_funding",
  },
  {
    mainHeading: "Post Fund Request API",
    mainHeadingDesc:
      "After providing all the credentials and getting a successful token from the API, users can post a fund request using this endpoint. Below is the URL to make a fund request:",
    mainGridId: "post-fund-request",
    accessTokenId: "required-input-post-fund-request",
    endpointId: "post-fund-request-endpoint",
    endPointHeading: "Request Endpoint",
    endPointMethod: "POST",
    endPointDesc: "<base_url>/connect/token",
    requestHeaderId: "post-fund-request-headers",
    requestHeader: "Request Headers",
    requestHeaderTable: { ...requestHeaderTableData },
    requestBodyId: "post-fund-request-body",
    requestBody: "Request Body",
    requestBodyDesc:
      "All fields must be passed in JSON format. Data type and naming conventions should be the same as below:",
    statusCodeCreated: "Status Code: 201(Created)",
    requestBodyTable: {
      columns: [
        { Header: "S/N", accessor: "num", align: "left", width: "5%" },
        {
          Header: "Field Name",
          accessor: "fieldName",
          align: "left",
          width: "10%",
        },
        { Header: "", accessor: "dataType", align: "center", width: "5%" },
        { Header: "Description", accessor: "description", align: "left" },
      ],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Amount<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          dataType: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Decimal"}
                variant="gradient"
                size="sm"
                sx={{ "& .MuiBadge-badge": { background: "#022DEC", backgroundImage: "none" } }}
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              All non-zero values with a maximum amount $50,000 with a maximum
              of 2 decimal places are acceptable.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              BackOfficeAccountNumber<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          dataType: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Text"}
                variant="gradient"
                size="sm"
                sx={{ "& .MuiBadge-badge": { background: "#022DEC", backgroundImage: "none" } }}
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              A string with a maximum length of 19 is acceptable for BackOffice
              Account Number. The following format needs to be followed:
              <br />
              <br />
              AAAA-BBB(B)-NNNNNN-C(C)
              <br />
              <br />
              <b>AAAA:</b> Four alphanumeric characters followed by a hyphen
              <br />
              <br />
              <b>BBB(B):</b> Three to four alphanumeric characters followed by a
              hyphen
              <br />
              <br />
              <b>NNNNNN:</b> Six numeric characters followed by a hyphen
              <br />
              <br />
              C(C): One or two characters between A-Z are acceptable including
              lower case characters
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              RequestTypeId<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          dataType: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Numeric/Int"}
                variant="gradient"
                size="sm"
                sx={{ "& .MuiBadge-badge": { background: "#022DEC", backgroundImage: "none" } }}
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Must be a numeric value of 1 because the system only accepts ACH
              Request Type for now.
              <br />
              <br />
              Value=1 ACH
              <br />
              Value=2 Wire
              <br />
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              4
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              TransactionTypeId<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          dataType: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Numeric/Int"}
                variant="gradient"
                size="sm"
                sx={{ "& .MuiBadge-badge": { background: "#022DEC", backgroundImage: "none" } }}
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Must be a numeric value of either 1 or 2.
              <br />
              <br />
              Value=1 Deposit to Customer A/C
              <br />
              Value=2 Withdraw from Customer A/C
              <br />
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Requestee<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          dataType: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
                sx={{ "& .MuiBadge-badge": { background: "#022DEC", backgroundImage: "none" } }}
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The username of the user generating the request.
            </MDTypography>
          ),
        },
      ],
    },
    // requestBodyImage: PFR,
    requestBodyImageId: "post-fund-request-header-example",
    respBodyId: "post-fund-response-body",
    respBody: "Response Body",
    respBodyDesc:
      "The following responses are possible against the POST requests made to the API:",
    respBodySuccessId: "post-fund-request-body-success",
    respBodySuccess:
      "The responses would be as below on the successful creation of fund requests.",
    respBodySuccessTable: {
      columns: [
        { Header: "S/N", accessor: "num", align: "left", width: "5%" },
        { Header: "Responses", accessor: "res", align: "left", width: "20%" },
        { Header: "Description", accessor: "desc", align: "left" },
      ],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          res: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              statusCode
            </MDTypography>
          ),
          desc: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              201 indicates the request is created.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          res: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              status
            </MDTypography>
          ),
          desc: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Indicates all required details are provided.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          res: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              fundRequestId
            </MDTypography>
          ),
          desc: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              69, is the actual Fund Request ID that will track the user's fund
              request record
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              4
            </MDTypography>
          ),
          res: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              bankingInstructionsSetupId
            </MDTypography>
          ),
          desc: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              20 is the Banking Instruction Setup ID.
            </MDTypography>
          ),
        },
      ],
    },
    respBodyValidationId: "post-fund-request-body-validation",
    respBodyValidation:
      "The responses would be as below in case of validation violations. ",
    respBodyValidationTable: {
      columns: [
        { Header: "S/N", accessor: "num", align: "left", width: "5%" },
        { Header: "Responses", accessor: "res", align: "left", width: "20%" },
        { Header: "Description", accessor: "desc", align: "left" },
      ],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          res: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Title
            </MDTypography>
          ),
          desc: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Title gives a brief description about the error. For instance, in
              the sample below, it indicates that one or more validation errors
              have occurred.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          res: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Status
            </MDTypography>
          ),
          desc: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Code 400 indicates a Bad Request Response, when a request does not
              meet the required conditions for the data passed to the API.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          res: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Errors
            </MDTypography>
          ),
          desc: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This part of the response highlights errors against invalid inputs
              provided in the API request.
            </MDTypography>
          ),
        },
      ],
    },
    // respBodyValidationTableTwo: {
    //     columns: [
    //         { Header: "S/N", accessor: "num", align: "left", width: "5%" },
    //         { Header: "Field Name", accessor: "fieldName", align: "left", width: "10%" },
    //         { Header: "", accessor: "dataType", align: "center", width: "5%" },
    //         { Header: "Description", accessor: "description", align: "left" },
    //     ],
    //     rows: [
    //         {
    //             num: (
    //                 <MDTypography component="p" variant="button" color="text" fontWeight="regular">
    //                     1
    //                 </MDTypography>),
    //             fieldName: (
    //                 <MDTypography component="p" variant="button" color="text" fontWeight="regular">
    //                     Amount<span style={{ color: "#ff4848" }}>*</span>
    //                 </MDTypography>
    //             ),
    //             dataType: (
    //                 <MDTypography component="p" variant="caption" color="text" fontWeight="regular">
    //                     <MDBadge color="success" badgeContent={"Decimal"} variant="gradient" size="sm"></MDBadge>
    //                 </MDTypography>
    //             ),
    //             description: (
    //                 <MDTypography component="p" variant="caption" color="text" fontWeight="regular">
    //                     All non-zero values with a maximum range of 15 digits along with a maximum of 6 decimal places are acceptable.
    //                 </MDTypography>
    //             ),
    //         },
    //         {
    //             num: (
    //                 <MDTypography component="p" variant="button" color="text" fontWeight="regular">
    //                     2
    //                 </MDTypography>),
    //             fieldName: (
    //                 <MDTypography component="p" variant="button" color="text" fontWeight="regular">
    //                     BackOfficeAccountNumber<span style={{ color: "#ff4848" }}>*</span>
    //                 </MDTypography>
    //             ),
    //             dataType: (
    //                 <MDTypography component="p" variant="caption" color="text" fontWeight="regular">
    //                     <MDBadge color="success" badgeContent={"Text"} variant="gradient" size="sm"></MDBadge>
    //                 </MDTypography>
    //             ),
    //             description: (
    //                 <MDTypography component="p" variant="caption" color="text" fontWeight="regular">
    //                     String with a maximum length of 19 is acceptable for Backoffice Account Number.  The following format needs to be followed:<br /><br />

    //                     AAAA-BBB(B)-NNNNNN-C(C)<br /><br />

    //                     <b>AAAA:</b> Four alphanumeric characters followed by a hyphen<br /><br />

    //                     <b>BBB(B):</b> Three to four alphanumeric characters followed by a hyphen<br /><br />

    //                     <b>NNNNNN:</b> Six numeric characters followed by a hyphen<br /><br />

    //                     C(C): One or two characters between A-Z are acceptable including lower case characters
    //                 </MDTypography>
    //             ),
    //         },
    //         {
    //             num: (
    //                 <MDTypography component="p" variant="button" color="text" fontWeight="regular">
    //                     3
    //                 </MDTypography>),
    //             fieldName: (
    //                 <MDTypography component="p" variant="button" color="text" fontWeight="regular">
    //                     RequestTypeId<span style={{ color: "#ff4848" }}>*</span>
    //                 </MDTypography>
    //             ),
    //             dataType: (
    //                 <MDTypography component="p" variant="caption" color="text" fontWeight="regular">
    //                     <MDBadge color="success" badgeContent={"Numeric/Int"} variant="gradient" size="sm"></MDBadge>
    //                 </MDTypography>
    //             ),
    //             description: (
    //                 <MDTypography component="p" variant="caption" color="text" fontWeight="regular">
    //                     Must be a numeric value of 1 because the system only accepts ACH Request Type for now.<br /><br />

    //                     Value=1 ACH<br />
    //                     Value=2 Wire<br />
    //                 </MDTypography>
    //             ),
    //         },
    //         {
    //             num: (
    //                 <MDTypography component="p" variant="button" color="text" fontWeight="regular">
    //                     4
    //                 </MDTypography>),
    //             fieldName: (
    //                 <MDTypography component="p" variant="button" color="text" fontWeight="regular">
    //                     TransactionTypeId<span style={{ color: "#ff4848" }}>*</span>
    //                 </MDTypography>
    //             ),
    //             dataType: (
    //                 <MDTypography component="p" variant="caption" color="text" fontWeight="regular">
    //                     <MDBadge color="success" badgeContent={"Numeric/Int"} variant="gradient" size="sm"></MDBadge>
    //                 </MDTypography>
    //             ),
    //             description: (
    //                 <MDTypography component="p" variant="caption" color="text" fontWeight="regular">
    //                     Must be a numeric value of either 1 or 2.<br /><br />

    //                     Value=1  Deposit to Customer A/C<br />

    //                     Value=2  Withdraw from Customer A/C<br />
    //                 </MDTypography>
    //             ),
    //         },
    //         {
    //             num: (
    //                 <MDTypography component="p" variant="button" color="text" fontWeight="regular">
    //                     5
    //                 </MDTypography>),
    //             fieldName: (
    //                 <MDTypography component="p" variant="button" color="text" fontWeight="regular">
    //                     Requestee<span style={{ color: "#ff4848" }}>*</span>
    //                 </MDTypography>
    //             ),
    //             dataType: (
    //                 <MDTypography component="p" variant="caption" color="text" fontWeight="regular">
    //                     <MDBadge color="success" badgeContent={"String"} variant="gradient" size="sm"></MDBadge>
    //                 </MDTypography>
    //             ),
    //             description: (
    //                 <MDTypography component="p" variant="caption" color="text" fontWeight="regular">
    //                     Must be a text and the value should be the name of the requestee with a maximum length of 100 is acceptable.<br /><br />
    //                     <b>Note:</b> Can't use digit or special characters.
    //                 </MDTypography>
    //             ),
    //         }
    //     ]
    // },
    reqObjKey: "fundRequest",
    respObjKey: "fundRequest",
    respValidationObjKey: "fundRequestValidation",
    validationObjKey: "fundRequestValidation",
  },
  {
    mainHeading: "External API Fund Request",
    mainHeadingDesc:
      "After providing all the credentials and getting a successful token from the API, external users can use that token as authorization passed in message headers to the API. Below is the URL to make a fund request as a user:",
    mainGridId: "external-api-fund-request",
    accessTokenId: "required-input-get-access-to-external-api",
    endpointId: "external-api-fund-request-endpoint",
    endPointHeading: "Request Endpoint",
    endPointMethod: "POST",
    endPointDesc: "<base-url>/api/fundsapproval/fundrequest",
    requestHeaderId: "get-access-to-external-request-headers",
    requestHeader: "Request Headers",
    requestHeaderTable: { ...requestHeaderTableData },
    requestBody: "Request Body",
    requestBodyDesc: "All fields must be passed in JSON format.",
    requestBodyTable: {
      columns: [
        { Header: "S/N", accessor: "num", align: "left", width: "5%" },
        { Header: "Field", accessor: "field", align: "left", width: "20%" },
        { Header: "", accessor: "dataType", align: "center", width: "5%" },
        { Header: "Description", accessor: "desc", align: "left" },
      ],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Amount<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          dataType: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Decimal"}
                variant="gradient"
                size="sm"
                sx={{ "& .MuiBadge-badge": { background: "#022DEC", backgroundImage: "none" } }}
              ></MDBadge>
            </MDTypography>
          ),
          desc: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              All non-zero values with a maximum amount $50,000 with a maximum
              of 2 decimal places are acceptable.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              FirstName<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          dataType: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Text"}
                variant="gradient"
                size="sm"
                sx={{ "& .MuiBadge-badge": { background: "#022DEC", backgroundImage: "none" } }}
              ></MDBadge>
            </MDTypography>
          ),
          desc: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Digits or special characters are not allowed except for
              apostrophes in the First Name.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              LastName<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          dataType: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Text"}
                variant="gradient"
                size="sm"
                sx={{ "& .MuiBadge-badge": { background: "#022DEC", backgroundImage: "none" } }}
              ></MDBadge>
            </MDTypography>
          ),
          desc: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Digits or special characters are not allowed except for
              apostrophes in Last Name.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              4
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Account Name<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          dataType: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Text"}
                variant="gradient"
                size="sm"
                sx={{ "& .MuiBadge-badge": { background: "#022DEC", backgroundImage: "none" } }}
              ></MDBadge>
            </MDTypography>
          ),
          desc: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              String with a maximum length of 50 is acceptable for Account Name.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              5
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Account<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          dataType: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Text"}
                variant="gradient"
                size="sm"
                sx={{ "& .MuiBadge-badge": { background: "#022DEC", backgroundImage: "none" } }}
              ></MDBadge>
            </MDTypography>
          ),
          desc: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              String must be numeric with a maximum length of 20 for Account.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              6
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              BackOfficeAccountNumber<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          dataType: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Text"}
                variant="gradient"
                size="sm"
                sx={{ "& .MuiBadge-badge": { background: "#022DEC", backgroundImage: "none" } }}
              ></MDBadge>
            </MDTypography>
          ),
          desc: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              String with a maximum length of 19 is acceptable for Backoffice
              Account Number. The following format needs to be followed:
              <br />
              <br />
              1AAA-BB5(B)-123141-C(C)
              <br />
              <br />
              <b>AAAA:</b> Four alphanumeric characters followed by a hyphen
              <br />
              <br />
              <b>BBB(B):</b> BBB(B): Three to four alphanumeric characters
              followed by a hyphen
              <br />
              <br />
              <b>NNNNNN:</b> Six numeric characters followed by a hyphen
              <br />
              <br />
              C(C): One or two characters between A-Z are acceptable including
              lower case characters
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              7
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              SWIFTABA<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          dataType: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Text"}
                variant="gradient"
                size="sm"
                sx={{ "& .MuiBadge-badge": { background: "#022DEC", backgroundImage: "none" } }}
              ></MDBadge>
            </MDTypography>
          ),
          desc: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              String with a numeric value and a maximum length of 20 is
              acceptable for SWIFT/ABA.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              8
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              AccountTypeId<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          dataType: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Numeric/Int"}
                variant="gradient"
                size="sm"
                sx={{ "& .MuiBadge-badge": { background: "#022DEC", backgroundImage: "none" } }}
              ></MDBadge>
            </MDTypography>
          ),
          desc: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Must be a numeric value of either 1 or 2.
              <br />
              <br />
              Value=1 <b>Checking</b> <br />
              Value=2 <b>Saving</b>
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              9
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              RequestTypeId<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          dataType: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Numeric/Int"}
                variant="gradient"
                size="sm"
                sx={{ "& .MuiBadge-badge": { background: "#022DEC", backgroundImage: "none" } }}
              ></MDBadge>
            </MDTypography>
          ),
          desc: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Must be a numeric value of 1 because the system only accepts ACH
              Request Type for now <br />
              <br />
              Value=1 ACH
              <br />
              Value=2 Wire
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              10
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              TransactionTypeId<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          dataType: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Numeric/Int"}
                variant="gradient"
                size="sm"
                sx={{ "& .MuiBadge-badge": { background: "#022DEC", backgroundImage: "none" } }}
              ></MDBadge>
            </MDTypography>
          ),
          desc: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Must be a numeric value of either 1 or 2.
              <br />
              <br />
              Value=1 Deposit to Customer A/C
              <br />
              <br />
              Value=2 Withdraw from Customer A/C.
              <br />
              <br />
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              11
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Address<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          dataType: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Text"}
                variant="gradient"
                size="sm"
                sx={{ "& .MuiBadge-badge": { background: "#022DEC", backgroundImage: "none" } }}
              ></MDBadge>
            </MDTypography>
          ),
          desc: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              String with a maximum length of 20 is acceptable for Address.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              12
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              CountryId<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          dataType: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Numeric/Int"}
                variant="gradient"
                size="sm"
                sx={{ "& .MuiBadge-badge": { background: "#022DEC", backgroundImage: "none" } }}
              ></MDBadge>
            </MDTypography>
          ),
          desc: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Must be a numeric value from the provided "countries.json" file
              against the "Id" key.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              13
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              StateId<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          dataType: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Numeric/Int"}
                variant="gradient"
                size="sm"
                sx={{ "& .MuiBadge-badge": { background: "#022DEC", backgroundImage: "none" } }}
              ></MDBadge>
            </MDTypography>
          ),
          desc: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Must be a numeric value from the provided "states.json" file
              against the "Id" key. The StateIds must be relevant to the Country
              provided in the CountryId field.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              14
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              City<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          dataType: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Text"}
                variant="gradient"
                size="sm"
                sx={{ "& .MuiBadge-badge": { background: "#022DEC", backgroundImage: "none" } }}
              ></MDBadge>
            </MDTypography>
          ),
          desc: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Digits or special characters are not allowed except for alphabets
              and apostrophes in the City field.
              <br />
              <br />
              Note: Apostrophes are not allowed at the beginning or end of the
              field
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              15
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              ZipCode<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          dataType: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Text"}
                variant="gradient"
                size="sm"
                sx={{ "& .MuiBadge-badge": { background: "#022DEC", backgroundImage: "none" } }}
              ></MDBadge>
            </MDTypography>
          ),
          desc: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Alphanumeric strings with a maximum length of 9 are allowed.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              16
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Id<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          dataType: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Numeric/Int"}
                variant="gradient"
                size="sm"
                sx={{ "& .MuiBadge-badge": { background: "#022DEC", backgroundImage: "none" } }}
              ></MDBadge>
            </MDTypography>
          ),
          desc: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Must be a numeric value, which will be Banking Instruction Setup
              ID.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              17
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              isDefault<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          dataType: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Boolean"}
                variant="gradient"
                size="sm"
                sx={{ "& .MuiBadge-badge": { background: "#022DEC", backgroundImage: "none" } }}
              ></MDBadge>
            </MDTypography>
          ),
          desc: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Must be a Boolean, either true or false.
              <br />
              <br />
              This field will be used to set the default Bank Account, i.e.,
              value True will set it to the default Bank Account.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              18
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Action<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          dataType: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Text"}
                variant="gradient"
                size="sm"
                sx={{ "& .MuiBadge-badge": { background: "#022DEC", backgroundImage: "none" } }}
              ></MDBadge>
            </MDTypography>
          ),
          desc: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Must be a text and the value should be either 'Add', 'Create' or
              'Update'.
              <br />
              <br />
              <ul>
                <li>
                  <b>"Update"</b>
                </li>

                <ul>
                  <li>
                    ID field is required. If only the Banking Instructions Setup
                    details are provided without funding details (Amount,
                    RequestTypeId, and TransactionTypeId), the API will update
                    the banking instruction found on the given Id, without
                    creating a funding request.
                  </li>
                </ul>

                <li>
                  <b>"Create"</b>
                </li>

                <ul>
                  <li>
                    ID is not required and the funding details (Amount,
                    RequestTypeId and TransactionTypeId) are optional. If
                    funding details are provided, the API will post a funding
                    request and add banking instructions, if they don't already
                    exists.
                  </li>
                </ul>

                <li>
                  <b> "Add"</b>
                </li>

                <ul>
                  <li>
                    ID is not required and funding details are optional. The API
                    will create a new banking instruction, and if the funding
                    details are provided, it will create a new fund request as
                    well.
                  </li>
                </ul>
              </ul>
              The difference between "Add" and "Create" is that "Create"
              requires funding request details. If they are not provided, only
              the Banking Instructions Setup is added without a funding request.
              With "Add," the Banking Instructions Setup is added, and the
              funding request details are optional. If provided, a funding
              request is posted as well.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              19
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Info
            </MDTypography>
          ),
          dataType: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Text"}
                variant="gradient"
                size="sm"
                sx={{ "& .MuiBadge-badge": { background: "#022DEC", backgroundImage: "none" } }}
              ></MDBadge>
            </MDTypography>
          ),
          desc: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              String with a maximum length of 100 is allowed for Info.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              20
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Apt
            </MDTypography>
          ),
          dataType: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Text"}
                variant="gradient"
                size="sm"
                sx={{ "& .MuiBadge-badge": { background: "#022DEC", backgroundImage: "none" } }}
              ></MDBadge>
            </MDTypography>
          ),
          desc: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              String with a maximum length of 14 is allowed for Apt.
            </MDTypography>
          ),
        },
      ],
    },

    // requestBodyImage: GAEE,
    requestBodyImageId: "get-access-to-external-example",
    respBodyId: "get-access-to-external-response-body",
    respBody: "Response Body",
    respBodyDesc:
      "The following responses are possible against the POST requests made to the API:",
    respBodySuccessId: "get-access-to-external-success",
    respBodySuccess:
      "The responses would be as below on the successful creation of fund requests.",
    respBodySuccessTable: {
      columns: [
        { Header: "S/N", accessor: "num", align: "left", width: "5%" },
        { Header: "Response", accessor: "res", align: "left", width: "10%" },
        { Header: "Description", accessor: "desc", align: "left" },
      ],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          res: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              statusCode
            </MDTypography>
          ),
          desc: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              201 indicates Created.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          res: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              status
            </MDTypography>
          ),
          desc: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Indicates everything is as expected.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          res: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              fundRequestId
            </MDTypography>
          ),
          desc: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              504 is the actual Fund Request ID that will track the user's fund
              request record.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              4
            </MDTypography>
          ),
          res: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              bankingInstructionSetupId
            </MDTypography>
          ),
          desc: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              213 is the Banking Instruction Setup ID.
            </MDTypography>
          ),
        },
      ],
    },
    respBodyValidationId: "get-access-to-external-validation",
    respBodyValidation:
      "The responses would be as below in case of validation violations. ",
    respBodyValidationTable: {
      columns: [
        { Header: "S/N", accessor: "num", align: "left", width: "5%" },
        { Header: "Response", accessor: "res", align: "left", width: "10%" },
        { Header: "Description", accessor: "desc", align: "left" },
      ],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          res: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Title
            </MDTypography>
          ),
          desc: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The title gives a brief description of the error. For instance, in
              the sample code above, it indicates that one or more validation
              errors have occurred.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          res: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              status
            </MDTypography>
          ),
          desc: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Code 400 indicates Bad Request Response, when a request does not
              meet the required conditions for the data passed to the API.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          res: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Errors
            </MDTypography>
          ),
          desc: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This part in the response highlights errors against invalid inputs
              provided in the API request.
            </MDTypography>
          ),
        },
      ],
    },
    externalValidationImg: GetAccessExernalValidation,
    reqObjKey: "getAccessToExternalAPI",
    respObjKey: "getAccessToExternalAPI",
    respValidationObjKey: "getAccessToExternalAPIValidation",
    validationObjKey: "getAccessToExternalAPIValidation",
  },
  {
    mainHeading: "GET Fund Request Details",
    mainHeadingDesc:
      "This API can be used to request details of the submitted fund request. To use this API, users must provide “FundRequestId” that was previously sent as a response to the created fund request.",
    mainGridId: "get-fund-req-details",
    endPointHeading: "Request Endpoint",
    endPointDesc: "<base-url>/api/fundsapproval/GetFundRequest?id=x",
    endpointId: "get-fund-request-details-endpoint",
    endPointMethod: "GET",
    requestHeaderId: "get-fund-request-details-req-headers",
    requestHeader: "Request Headers",
    requestHeaderTable: { ...requestHeaderTableData },
    requestHeaderNote: "Note: Here x needs to be replaced by the id",
    respBodyId: "get-fund-request-details-req-body",
    respBody: "Response Body",
    respBodyStatusCodeSuccess: "Status Code: 200 (Success)",
    respBodySuccessTableTwo: {
      columns: [
        { Header: "S/N", accessor: "num", align: "left", width: "5%" },
        { Header: "Field", accessor: "field", align: "left", width: "10%" },
        { Header: "", accessor: "dataType", align: "center", width: "5%" },
        { Header: "Description", accessor: "desc", align: "left" },
      ],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Id<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          dataType: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Numeric/Int"}
                variant="gradient"
                size="sm"
                sx={{ "& .MuiBadge-badge": { background: "#022DEC", backgroundImage: "none" } }}
              ></MDBadge>
            </MDTypography>
          ),
          desc: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Must be a numeric value, which will be Fund Request ID.
            </MDTypography>
          ),
        },
      ],
    },
    // respBodyImg: GFRD,
    respObjKey: "getFundRequestDetails",
  },
  {
    parentHeading: "GET All Fund Requests",
    parentId: "get-all-fund-req",
    mainGridId: "get-all-fund-req",
  },
  {
    mainGridId: "get-all",
    parentId: "get-all-fund-req-child",
    mainHeading: "Get All",
    mainHeadingDesc:
      "By using this endpoint, users can request details of all fund requests in the system. ",
    endPointHeading: "Request Endpoint",
    endPointDesc: "<base-url>/api/fundsapproval/GetAll",
    endpointId: "get-all-endpoint",
    endPointMethod: "GET",
    requestHeaderId: "get-all-headers",
    requestHeader: "Request Headers",
    requestHeaderTable: { ...requestHeaderTableData },
    respBodyId: "get-all-req-body",
    respBody: "Response Body",
    respBodyStatusCodeSuccess: "Status Code: 200 (Success)",
    respObjKey: "getallsingle",
  },
  {
    parentId: "get-all-fund-req",
    mainHeading: "Get Specific Fund Requests",
    mainHeadingDesc: `By using paging to request data, the data will be returned based on the input. The default page number and size are 1 and 1000, respectively. Otherwise, all fund requests will be received.`,
    mainGridId: "get-specific-fund-req",
    endPointHeading: "Request Endpoint",
    endPointDesc: "<base-url>/api/fundsapproval/GetAll?pageNo=1&pageSize=50",
    endpointId: "get-specific-fund-req-endpoint",
    endPointMethod: "GET",
    requestHeaderId: "get-specific-fund-req-headers",
    requestHeader: "Request Headers",
    requestHeaderTable: { ...requestHeaderTableData },
    respBodyId: "get-specific-fund-req-body",
    respBody: "Response Body",
    respBodyStatusCodeSuccess: "Status Code: 200 (Success)",
    respObjKey: "getSpecificfundRequests",
  },
  {
    parentId: "get-all-fund-req",
    mainHeading: "Get All Banking Instructions",
    mainHeadingDesc:
      "Users can request details of all the banking instructions against a created fund request. To use this API, a “BackOffice Account Number” is required for the respective banking instructions.",
    mainGridId: "get-all-banking-instruction",
    endPointHeading: "Request Endpoint",
    endPointDesc:
      "<base-url>/api/BankingInstruction/GetAll?backOfficeAccountNo=x",
    endpointId: "get-all-banking-instruction-endpoint",
    endPointMethod: "GET",
    requestHeaderId: "get-all-banking-instruction-req-headers",
    requestHeader: "Request Headers",
    requestHeaderTable: { ...requestHeaderTableData },
    requestHeaderNote:
      "	Note: Here x needs to be replaced by the BackOfficeAccount#",
    respBodyId: "get-all-banking-instruction-req-body",
    respBody: "Response Body",
    respBodyStatusCodeSuccess: "Status Code: 200 (Success)",
    respObjKey: "getAllbankingDetailsInst",
  },
  {
    parentId: "get-all-fund-req",
    mainHeading: "Get All Audit Trails",
    mainHeadingDesc:
      '“Back Office Account Number" is required to get all the “Audit Trails” that exist against it. By using paging to request data, the data will be returned based on the input. Otherwise, all fund requests will be received. The default page number and size are 1 and 1000, respectively.',
    mainGridId: "get-all-audit-trails",
    endPointHeading: "Request Endpoint",
    endPointDesc:
      "<base-url/api/AuditTrails/GetAll?backOfficeAccountNo=x&pageno=1&pagesize=100",
    endpointId: "get-all-audit-trails-endpoint",
    endPointMethod: "GET",
    requestHeaderId: "get-all-audit-trails-headers",
    requestHeader: "Request Headers",
    requestHeaderTable: { ...requestHeaderTableData },
    respBodyId: "get-all-audit-trails-body",
    requestHeaderNote: "Here x needs to be replaced by the BackOfficeAccount# ",
    respBody: "Response Body",
    respBodyStatusCodeSuccess: "Status Code: 200 (Success)",
    respBodySuccessTable: {
      columns: [
        { Header: "S/N", accessor: "num", align: "left", width: "5%" },
        { Header: "Field", accessor: "field", align: "left", width: "10%" },
        { Header: "", accessor: "dataType", align: "center", width: "5%" },
        { Header: "Description", accessor: "desc", align: "left" },
      ],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              BackOfficeAccountNo<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          dataType: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Text"}
                variant="gradient"
                size="sm"
                sx={{ "& .MuiBadge-badge": { background: "#022DEC", backgroundImage: "none" } }}
              ></MDBadge>
            </MDTypography>
          ),
          desc: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              A string with a maximum length of 19 is acceptable for Backoffice
              Account Number. The following format needs to be followed:
              <br />
              <br />
              1AAA-BB5(B)-123141-C(C)
              <br />
              <br />
              <b>AAAA:</b> Four alphanumeric characters followed by a hyphen
              <br />
              <br />
              <b>BBB(B):</b> Three to four alphanumeric characters followed by a
              hyphen
              <br />
              <br />
              <b>NNNNNN:</b> Six numeric characters followed by a hyphen
              <br />
              <br />
              C(C): One or two characters between A-Z are acceptable including
              lower case characters
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              PageNo<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          dataType: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Numeric/Int"}
                variant="gradient"
                size="sm"
                sx={{ "& .MuiBadge-badge": { background: "#022DEC", backgroundImage: "none" } }}
              ></MDBadge>
            </MDTypography>
          ),
          desc: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Must be a numeric value, which will be Fund Request ID.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              PageSize<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          dataType: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Numeric/Int"}
                variant="gradient"
                size="sm"
                sx={{ "& .MuiBadge-badge": { background: "#022DEC", backgroundImage: "none" } }}
              ></MDBadge>
            </MDTypography>
          ),
          desc: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Must be a numeric value, which will be Fund Request ID.
            </MDTypography>
          ),
        },
      ],
    },

    // respBodyImg: GAFROne,
    // respBodyImg2: GAFRTwo,
    respObjKey: "getAllAuditTrails",
  },
  {
    parentId: "get-all-fund-req",
    mainHeading: "Get All Audit Trails By Date",
    mainHeadingDesc:
      '"Back Office Account Number" is required to get all the “Audit Trails” that exist against it. By using paging to request data, the data will be returned based on the input. Otherwise, all fund requests will be received. The default page number and size are 1 and 1000, respectively.',
    mainGridId: "get-all-audit-trails-by-date",
    endPointHeading: "Request Endpoint",
    endPointDesc:
      "<base-url/api/AuditTrails/GetAllByDate?backOfficeAccountNo=X&pageno=1&pagesize=5&startDate=2022-08-18T12:50:14.23583&endDate=2022-08-18T12:50:14.23583",
    endpointId: "get-all-audit-trails-by-date-endpoint",
    endPointMethod: "GET",
    requestHeaderId: "get-all-audit-trails-by-date-headers",
    requestHeader: "Request Headers",
    requestHeaderTable: { ...requestHeaderTableData },
    respBodyId: "get-all-audit-trails-by-date-body",
    requestHeaderNote: "Here X needs to be replaced by the BackOfficeAccount# ",
    respBody: "Response Body",
    respBodyStatusCodeSuccess: "Status Code: 200 (Success)",
    respBodySuccessTable: {
      columns: [
        { Header: "S/N", accessor: "num", align: "left", width: "5%" },
        { Header: "Field", accessor: "field", align: "left", width: "10%" },
        { Header: "", accessor: "dataType", align: "center", width: "5%" },
        { Header: "Description", accessor: "desc", align: "left" },
      ],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              BackOfficeAccountNo<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          dataType: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Text"}
                variant="gradient"
                size="sm"
                sx={{ "& .MuiBadge-badge": { background: "#022DEC", backgroundImage: "none" } }}
              ></MDBadge>
            </MDTypography>
          ),
          desc: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              A string with a maximum length of 19 is acceptable for Backoffice
              Account Number. The following format needs to be followed:
              <br />
              <br />
              1AAA-BB5(B)-123141-C(C)
              <br />
              <br />
              <b>AAAA:</b> Four alphanumeric characters followed by a hyphen
              <br />
              <br />
              <b>BBB(B):</b> Three to four alphanumeric characters followed by a
              hyphen
              <br />
              <br />
              <b>NNNNNN:</b> Six numeric characters followed by a hyphen
              <br />
              <br />
              C(C): One or two characters between A-Z are acceptable including
              lower case characters
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              PageNo<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          dataType: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Numeric/Int"}
                variant="gradient"
                size="sm"
                sx={{ "& .MuiBadge-badge": { background: "#022DEC", backgroundImage: "none" } }}
              ></MDBadge>
            </MDTypography>
          ),
          desc: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Must be a numeric value, which will be Fund Request ID.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              PageSize<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          dataType: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Numeric/Int"}
                variant="gradient"
                size="sm"
                sx={{ "& .MuiBadge-badge": { background: "#022DEC", backgroundImage: "none" } }}
              ></MDBadge>
            </MDTypography>
          ),
          desc: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Must be a numeric value, which will be Fund Request ID.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              StartDate<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          dataType: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Date&Time"}
                variant="gradient"
                size="sm"
                sx={{ "& .MuiBadge-badge": { background: "#022DEC", backgroundImage: "none" } }}
              ></MDBadge>
            </MDTypography>
          ),
          desc: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              5
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              EndDate<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          dataType: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Date&Time"}
                variant="gradient"
                size="sm"
                sx={{ "& .MuiBadge-badge": { background: "#022DEC", backgroundImage: "none" } }}
              ></MDBadge>
            </MDTypography>
          ),
          desc: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
        },
      ],
    },

    // respBodyImg: GAFROne,
    // respBodyImg2: GAFRTwo,
    respObjKey: "getAllAuditTrailsByDate",
  },

  {
    mainHeadingStatic: "Disclaimer and Confidentiality Notice",
    mainGridIdStatic: "disclaimer",
    mainHeadingDescStatic: `The information contained in these documents is confidential, privileged, and only for the understanding of the intended recipient and may not be used, published, or redistributed without prior written consent from Gato Systems.`,
    mainHeadingDescStaticTwo: `The information is provided with care in these documents, Gato Systems makes no representations and gives no warranties of whatever nature in respect of these documents, including, but not limited to, the accuracy or completeness of any information, facts, and/or opinions contained therein. Gato Systems, its subsidiaries, the directors, employees, and agents cannot be held liable for the use of, and reliance on the information provided in these documents.`,
  },
];

export default fundingApiData;